import { render, staticRenderFns } from "./ChatHelpdesk.vue?vue&type=template&id=c1340b28&scoped=true"
import script from "./ChatHelpdesk.vue?vue&type=script&lang=js"
export * from "./ChatHelpdesk.vue?vue&type=script&lang=js"
import style0 from "./ChatHelpdesk.vue?vue&type=style&index=0&id=c1340b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1340b28",
  null
  
)

export default component.exports